import { BaseModel } from '~/models/baseModel';

export class StateModel extends BaseModel {
    public name:string;
    public longName:string;
}